import { Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import Logo from "../../assets/SVG/Logo.svg";
import GlobalIcon from "../GlobalIcon/GlobalIcon";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Avatar from "../Avatar/Avatar";
import ThemeToggle from "../ThemeToggle/ThemeToggle";

function Navbar({ onToggleSidebar }) {
  const location = useLocation();
  const isFundsActive = location.pathname === "/funds";

  return (
    <div className={styles["navbar"]}>
      <div className={styles["navbar-brand"]}>
        <img src={Logo} alt="Logo" className={styles["navbar-logo"]} />
      </div>
      <button
        className={styles["navbar-toggle"]}
        onClick={onToggleSidebar}
        aria-label="Toggle sidebar"
      >
        <GlobalIcon
          iconName="HamburgerMenu"
          className={styles["hamburger-icon"]}
          aria-label="Menu"
        />
      </button>
      <Breadcrumb />
      <div className={styles["navbar-actions"]}>
        <Link
          to="/funds"
          className={`${styles["navbar-action-button"]} ${isFundsActive ? styles["navbar-action-button-active"] : ""}`}
          aria-label="Funds"
        >
          <GlobalIcon
            iconName="FundsIcon"
            className={styles["action-button-icon"]}
          />
          <span className={styles["action-button-text"]}>Funds</span>
        </Link>
        <ThemeToggle />
        <button className={styles["navbar-notification"]} aria-label="Notifications">
          <GlobalIcon
            iconName="NotificationIcon"
            className={styles["notification-icon"]}
          />
        </button>
        <Avatar />
      </div>
    </div>
  );
}

export default Navbar;
